import styles from "./styles/ContentItemPage.module.scss";
import WatsonApi from "../backends/WatsonApi";
import useSWR from "swr";
import NotificationManager from "../components/notifications/NotificationManager";
import SchoolBlocksLoadingIndicator from "../components/utilities/SchoolBlocksLoadingIndicator";
import {ReactiveContentItem} from "../stores/SchoolFeedStore";
import NewsModalContent from "../components/modals/NewsModal/NewsModalContent";
import {deleteContentItem} from "../components/blocks/TerracedGridTheme/Terrace";
import {useEffect} from "react";
import SafeRouter from "../components/utilities/SafeRouter";
import {getPaths} from "../utils/SchoolBlocksUtilities";
import {withoutLocaleInURI} from "../internationalization/i18nURI";
import {useStores} from "../stores/useStores";

export default function NewsItemPage() {
    const {interfaceStore, userStore, modalStore} = useStores();

    const pathSegments: string[] = getPaths(withoutLocaleInURI(interfaceStore.currentFullUrl));
    const contentItemId = pathSegments[pathSegments.length - 1];
    const orgId = pathSegments[pathSegments.length - 2];

    const {data, isLoading} = useSWR(`contentItem/${contentItemId}`, async () => {
        try {
            const client = await WatsonApi();
            const result = await client.apis.organizations.organizations_content_items_read({
                organization_pk: orgId,
                id: contentItemId,
                is_news: true,
                expand: ["organization"],
            });
            return new ReactiveContentItem(result.obj);
        } catch (e) {
            NotificationManager.error(e.response.body.detail);
        }
    }, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
    });

    useEffect(() => {
        if (process.env.MERITOCRACY_CHAT_ENABLED && data && data.meritchat_enabled && !userStore.id) {
            modalStore.addModal({
                type: "login",
            })
        }
    }, [data])

    async function handleDelete(contentItem) {
        await deleteContentItem(contentItem);
        SafeRouter.push('/');
    }

    return <div className={styles.container}>
        {isLoading ? <div className={styles.loadingIndicator}>
            <SchoolBlocksLoadingIndicator fill={"var(--fontColor)"} />
        </div> : data ? <NewsModalContent closeFunction={() => SafeRouter.push('/')}
                                          itemObj={data} index={0}
                                          handleDelete={handleDelete}/>
            : <div className={styles.loadingIndicator}>Content Item not found.</div>}
    </div>
}
